export const APP = 'dashboard-app-index';
export const CRED = '9d9f5a6a6c11:909dea26-2367-497b-b8cb-525bb6d5f718';
export const AUTH0_CLIENT = 'oQYr3qet33ObFqLcvsuWEn4QrE455V1Q';
export const AUTH0_DOMAIN = 'appbase-io.us.auth0.com';
export const URL = 'https://appbase-demo-ansible-abxiydt-arc.searchbase.io';
export const TYPE = '_doc';

export const abbrevations = {
	PS2: {
		name: 'Playstation 2',
		styles: {
			backgroundImage: `linear-gradient(to right, rgba(71, 98, 247, 0.2), rgba(63, 81, 181, 0.3)), url('https://images.unsplash.com/photo-1550342583-e47260731784?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
		},
	},
	DS: {
		name: 'Nintendo DS',
		styles: {
			backgroundImage: `linear-gradient(to right, rgba(71, 98, 247, 0.2), rgba(63, 81, 181, 0.3)), url('https://images.unsplash.com/photo-1531594835867-65b60cc9e4ff?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
		},
	},
	PS3: {
		name: 'Playstation 3',
		styles: {
			backgroundImage: `linear-gradient(to right, rgba(71, 98, 247, 0.2), rgba(63, 81, 181, 0.3)), url('https://images.unsplash.com/photo-1526510096283-b0b3b6cac327?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
		},
	},
	Wii: {
		name: 'Wii',
		styles: {
			backgroundImage: `linear-gradient(to right, rgba(71, 98, 247, 0.2), rgba(63, 81, 181, 0.3)), url('https://images.unsplash.com/10/wii.jpg?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
		},
	},
	X360: {
		name: 'Xbox 360',
		styles: {
			backgroundImage: `linear-gradient(to right, rgba(71, 98, 247, 0.2), rgba(63, 81, 181, 0.3)), url('https://images.unsplash.com/photo-1532219600601-8494408a4a2c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2089&q=80')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
		},
	},
	PSP: {
		name: 'Playstation P',
		styles: {
			backgroundImage: `linear-gradient(to right, rgba(71, 98, 247, 0.2), rgba(63, 81, 181, 0.3)), url('https://images.unsplash.com/photo-1513599898445-1c34777500ab?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1947&q=80')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
		},
	},
};
